export const SET_MESSAGE = 'form/SET_MESSAGE';
export const UNSET_MESSAGE = 'form/UNSET_MESSAGE';
export const CLEAR_MESSAGE = 'form/CLEAR_MESSAGE';

export const ERROR = 'error';
export const SUCCESS = 'success';
export const WARNING = 'warning';
export const INFO = 'info';

export const setMessage = (messageType, content, fieldErrors, raw, slotId = 'default', timeout) => (
  {
    type: SET_MESSAGE,
    messageType,
    content,
    fieldErrors,
    raw,
    slotId,
    timeout
  }
);

export const unsetMessage = (id, slotId = 'default') => ({
  type: UNSET_MESSAGE,
  id,
  slotId
});

export const clearMessage = (slotId = 'default') => ({
  type: CLEAR_MESSAGE,
  slotId
});
